export function sortYears(yearData) {
  return Object.keys(yearData || {}).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
}

export function getVisibleYears(yearData, historyWindow) {
  const years = sortYears(yearData);

  switch(historyWindow) {
    case 'recent':
      return years.slice(-3);
    case '5y':
      return years.slice(-5);
    case '10y':
      return years.slice(-10);
    case 'all':
    default:
      return years;
  }
}

export function getLatestYear(yearData) {
  const years = sortYears(yearData);
  return years[years.length - 1] || null;
}

export function getYearCountLabel(yearData) {
  const years = sortYears(yearData);

  if(years.length === 0) return 'No history';
  if(years.length === 1) return '1 year';
  return years.length + ' years';
}

export function parseNumericValue(value) {
  if(!value || typeof value !== 'string') return null;

  const match = value.replace(/,/g, '').match(/[-\d.]+/);
  if(!match) return null;

  const numeric = parseFloat(match[0]);
  return Number.isNaN(numeric) ? null : numeric;
}

export function getTrendSummary(yearData, visibleYears) {
  if(!yearData || visibleYears.length < 2) return null;

  const firstYear = visibleYears[0];
  const lastYear = visibleYears[visibleYears.length - 1];
  const firstValue = parseNumericValue(yearData[firstYear]);
  const lastValue = parseNumericValue(yearData[lastYear]);

  if(firstValue === null || lastValue === null || firstValue === 0) return null;

  const delta = ((lastValue - firstValue) / Math.abs(firstValue)) * 100;
  const direction = delta >= 0 ? 'up' : 'down';

  return {
    direction,
    delta: Math.abs(delta).toFixed(1),
    label: Math.abs(delta).toFixed(1) + '% ' + direction
  };
}

export function getMaxHistoryLength(metricGroups) {
  return metricGroups.reduce((maxCount, metric) => {
    const yearCount = sortYears(metric.yearData).length;
    return yearCount > maxCount ? yearCount : maxCount;
  }, 0);
}
